import { render } from "./ResultStatic.vue?vue&type=template&id=15fc556c&scoped=true"
import script from "./ResultStatic.vue?vue&type=script&lang=js"
export * from "./ResultStatic.vue?vue&type=script&lang=js"

import "./ResultStatic.vue?vue&type=style&index=0&id=15fc556c&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fc556c"]])

export default __exports__